'use strict';

// export this package's api
module.exports = require('./Pagination');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.7.5@rc-pagination/lib/index.js
 ** module id = 424
 ** module chunks = 0 1
 **/